import { FormGroupHeader } from "@/components/shared";
import { EditTenderContext } from "@/layouts/EditTenderLayout";
import { useTranslation } from "react-i18next";
import { useOutletContext, useParams } from "react-router-dom";
import GenerateOpenCalculationsComponent from "./Components/GenerateOpenCalculationsComponent";
import ArchiveTenderComponent from "./Components/ArchiveTenderComponent";
import { useTenderPermissionsData } from "@/hooks/cache";

/**
 * Options component for the Edit Tender page.
 * Provides a layout for various tender options and actions.
 *
 * @component
 */
function OptionsComponent() {
  const { t } = useTranslation(["translation"]);
  const { tenderByIdData } = useOutletContext<EditTenderContext>();
  const { tenderID } = useParams<{ tenderID: string }>();
  const { canArchive } = useTenderPermissionsData(Number(tenderID));

  const tenderState = tenderByIdData?.fetchTenderById?.state;

  return (
    <div>
      <FormGroupHeader
        title={t("edittender.options.title")}
        description={t("edittender.options.description")}
        className="pr-4 pl-2"
      />
      <div className="flex flex-col gap-4 pb-[300px] pr-4 pl-2">
        <GenerateOpenCalculationsComponent tenderState={tenderState} tenderID={tenderID} />
        {canArchive && <ArchiveTenderComponent tenderByIdData={tenderByIdData} />}
      </div>
    </div>
  );
}

export default OptionsComponent;
